import { render, staticRenderFns } from "./WebText.vue?vue&type=template&id=3d6d5577&"
import script from "./WebText.vue?vue&type=script&lang=js&"
export * from "./WebText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports